
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class InvoiceBillingItemsReportDialog extends Serenity.EntityDialog<InvoiceBillingItemsReportRow, any> {
        protected getFormKey() { return InvoiceBillingItemsReportForm.formKey; }
        protected getIdProperty() { return InvoiceBillingItemsReportRow.idProperty; }
        protected getLocalTextPrefix() { return InvoiceBillingItemsReportRow.localTextPrefix; }
        protected getNameProperty() { return InvoiceBillingItemsReportRow.nameProperty; }
        protected getService() { return InvoiceBillingItemsReportService.baseUrl; }
        protected getDeletePermission() { return InvoiceBillingItemsReportRow.deletePermission; }
        protected getInsertPermission() { return InvoiceBillingItemsReportRow.insertPermission; }
        protected getUpdatePermission() { return InvoiceBillingItemsReportRow.updatePermission; }

        protected form = new InvoiceBillingItemsReportForm(this.idPrefix);

    }
}